export default "__VITE_ASSET__CuXOzWIw__"